import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { UserService } from '@services/core/user.service';
import { of } from 'rxjs';
import { switchMap, map } from 'rxjs/operators';

export const menusResolver: ResolveFn<any> = () => {
  const userService = inject(UserService)
  return fetchMenus(userService)
}

function fetchMenus(userService: UserService) {
  return userService.getRoles().pipe(
    switchMap((roles: any[]) => pickRole(userService, roles))
  )
}

function pickRole(userService: UserService, roles: any[]) {
  if (!roles?.length) return emptyMenus();
  return roleMenus(userService, roles)
}

function emptyMenus() {
  return of({ roles: [], roleSelected: null, menus: [] })
}

function roleMenus(userService: UserService, roles: any[]) {
  const selected = firstRole(roles);
  return userService.getMenuByRole(selected).pipe(
    map((menus: any) => buildMenus(roles, selected, menus))
  )
}

function firstRole(roles: any[]): string {
  return roles[0].id
}

function buildMenus(roles: any[], roleSelected: string, menus: any[]) {
  return { roles, roleSelected, menus };
}
